import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import api, { GenericError } from "../api"
import { CreateGroupRequest, GroupModel, UpdateGroupRequest } from "../api/group.api"

export interface GroupsListState {
    groups: GroupModel[]
    loading: boolean
    //TODO: make error interface
    error?: GenericError
    success?: boolean
    modulesAndMenus?: Record<string, any>[]
}

const initialState: GroupsListState = {
    groups: [],
    loading: false
}

export const loadGroups = createAsyncThunk("groups/list", async (thunkAPI) => {
    try {
        const response = await api.group.groupsList()

        return response
    } catch (error: any) {
        console.log(error)
    }
})

export const createGroup = createAsyncThunk(
    "groups/create",
    async (newGroupData: CreateGroupRequest, thunkAPI) => {
        try {
            const response = await api.group.createGroup(newGroupData)

            return response
        } catch (error: any) {
            console.log(error)
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const updateGroup = createAsyncThunk(
    "groups/update",
    async (existingGroupData: UpdateGroupRequest, thunkAPI) => {
        try {
            const response = await api.group.updateGroup(existingGroupData)

            return response
        } catch (error: any) {
            console.log(error)
            return thunkAPI.rejectWithValue(error)
        }
    }
)

export const deleteGroup = createAsyncThunk("groups/delete", async (groupId: number, thunkAPI) => {
    try {
        const response = await api.group.deleteGroup(groupId)

        return response
    } catch (error: any) {
        console.log(error)
        return thunkAPI.rejectWithValue(error)
    }
})

export const groupsSlice = createSlice({
    name: "groups",
    initialState,

    reducers: {
        clearError: (state: GroupsListState) => {
            state.error = undefined
        },
        resetSuccess: (state: GroupsListState) => {
            state.success = undefined
        }
    },

    extraReducers: {
        [loadGroups.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [loadGroups.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [loadGroups.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.groups = action.payload?.data?.data?.payload?.groups || []
            state.modulesAndMenus = action.payload?.data?.data?.payload?.modules || []
        },

        [createGroup.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [createGroup.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [createGroup.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            // state.groups = action.payload.data.payload.data
        },

        [updateGroup.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [updateGroup.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [updateGroup.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            // state.groups = action.payload.data.payload.data
        },

        [deleteGroup.pending.toString()]: (state, action) => {
            state.loading = true
        },
        [deleteGroup.rejected.toString()]: (state, action) => {
            state.loading = false
            if (action.payload?.response?.data?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.data?.payload }
            } else if (action.payload?.response?.data?.payload) {
                state.error = { payload: action.payload?.response?.data?.payload }
            } else if (action.payload?.response?.data?.data?.error) {
                state.error = { error: action.payload?.response?.data?.data?.error }
            } else {
                state.error = { error: action.payload?.response?.data?.error }
            }
        },
        [deleteGroup.fulfilled.toString()]: (state, action) => {
            state.loading = false
            state.success = true
            // state.warehouses = action.payload.data.payload.data
        }
    }
})

export const { clearError, resetSuccess } = groupsSlice.actions

export default groupsSlice.reducer
